import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import {
  VVE_CHECKOUT_MODAL_SUBTITLE,
  VVE_CHECKOUT_MODAL_TITLE,
  VVE_TEXT_CHECKOUT,
  VVE_TEXT_USER_SELECTED,
} from '../../../brands/default/constants';
import { LINK_VVE_TERMS } from '../../../brands/default/links';
import ThemeContext from '../../../providers/ThemeProvider';
import WowModal from '../../WowModal';
import VoucherValidityItem from './VoucherValidityItem';

const VoucherValidityExtension = ({
  bt,
  currency,
  extraClasses,
  hasLoadingSpinner,
  paymentOptions,
  isWalletAllowed,
  totalWalletApplicableOrderAmount,
  vveSummary,
}) => {
  const theme = useContext(ThemeContext);
  const [showVVEModal, setIsShowVVEModal] = useState();

  const isVveAdded = vveSummary.some(
    (voucher) => voucher.userSelectedQuantity > 0,
  );

  return (
    <div className={classNames('vve-text', extraClasses)}>
      <button
        className="vve-text__link"
        onClick={() => setIsShowVVEModal(true)}
        type="button"
      >
        {isVveAdded > 0 ? VVE_TEXT_USER_SELECTED : VVE_TEXT_CHECKOUT}
      </button>
      {showVVEModal && (
        <WowModal
          ariaLabelledBy=""
          centered
          setShowModal={setIsShowVVEModal}
          showCloseButton
          showModal={showVVEModal}
          size="lg"
          title={VVE_CHECKOUT_MODAL_TITLE}
          titleClasses="vve-header"
          vveModal
        >
          <div className="modal-scroller">
            <p className="vve-sub-title">{VVE_CHECKOUT_MODAL_SUBTITLE}</p>
            <p className="vve-terms">
              View T&Cs{' '}
              <a
                className="link-text"
                href={LINK_VVE_TERMS}
                rel="noreferrer"
                target="_blank"
              >
                here
              </a>
            </p>
            {vveSummary.map(function (vveExtensionItem) {
              return (
                <VoucherValidityItem
                  // canBuyNow={canBuyNow}
                  bt={bt}
                  key={`extension-${vveExtensionItem.orderLineId}`}
                  vveExtensionItem={vveExtensionItem}
                />
              );
            })}
          </div>
        </WowModal>
      )}
      <style jsx>{`
        .modal-scroller {
          max-height: 300px;
          overflow-y: auto;
          padding-right: 4px;
        }
        .vve-sub-title {
          margin: 0px auto;
          width: fit-content;
        }
        .vve-text {
          position: relative;
        }
        .vve-text__link {
          display: block;
          color: ${theme.colors.primary};
          margin-bottom: 10px;
          font-size: 85%;
          background: none;
          cursor: pointer;
          border: none;
          padding: 0;
        }
        .vve-text__link:hover {
          cursor: pointer;
          color: #23527c;
        }
        .vve-terms {
          margin-top: 4px;
          text-align: center;
          color: #b3b3b3;
          font-size: 13px;
        }
        .link-text {
          text-decoration: underline;
          color: inherit;
        }
        .link-text :hover {
          cursor: pointer;
        }
        .vve-text :global(.redeem-code__close) {
          position: absolute;
          margin: 15px;
          top: 0px;
          right: 0px;
          line-height: 0;
          color: ${theme.colors.primary};
        }
        .vve-text :global(.redeem-code__close):hover {
          cursor: pointer;
          color: #23527c;
        }
        @media (max-width: 768px) {
          .vve-sub-title {
            text-align: center;
          }
        }
      `}</style>
    </div>
  );
};

VoucherValidityExtension.propTypes = {
  bt: PropTypes.string,
  creditBalances: PropTypes.array,
  currency: PropTypes.string,
  extraClasses: PropTypes.string,
  hasLoadingSpinner: PropTypes.func,
  isWalletAllowed: PropTypes.bool,
  paymentOptions: PropTypes.object,
  totalWalletApplicableOrderAmount: PropTypes.number,
  vveSummary: PropTypes.array,
};

export default VoucherValidityExtension;
